import { render, staticRenderFns } from "./NotificationsSidebar.vue?vue&type=template&id=fa95c60c&scoped=true"
import script from "./NotificationsSidebar.vue?vue&type=script&lang=js"
export * from "./NotificationsSidebar.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSidebar.vue?vue&type=style&index=0&id=fa95c60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa95c60c",
  null
  
)

export default component.exports